export default () => ({
    articles: null,
    article: null,
    articlesConfig: {
        include: 'coverMedia,createdBy,translations',
        sort: 'id',
        sortDirection: 'desc',
        page: 1,
        per_page: 25,
        filters: {}
    }
})
